import React, { useCallback, useEffect, useState } from 'react';
import { useRestClient } from '../core/api/RestClientContext';
import { XuiServerConfig } from '../core/models/xui';
import { SyncActionsPanel } from '../domains/xui/components/SyncActionsPanel';
import { SyncLinksList } from '../domains/xui/components/SyncLinksList';
import XuiExportDialog from '../domains/xui/components/XuiExportDialog';
import { XuiServersRegistryPanel } from '../domains/xui/components/XuiServersRegistryPanel';
import './SyncActionPage.css';

export const SyncActionPage: React.FC = () => {
    const restClient = useRestClient();
    const [xuiServers, setXuiServers] = useState<XuiServerConfig[]>([]);
    const [showXuiExport, setShowXuiExport] = useState(false);

    const loadServers = useCallback(async () => {
        try {
            const servers = await restClient.getXuiHosts();
            setXuiServers(servers);
        } catch (error) {
            console.error('Failed to load xui hosts', error);
        }
    }, [restClient]);

    useEffect(() => {
        loadServers();
    }, [loadServers]);

    return (
        <div className="sync-action-page">
            {showXuiExport && (
                <XuiExportDialog onClose={() => setShowXuiExport(false)} />
            )}
            <div className="sync-action-servers">
                <XuiServersRegistryPanel servers={xuiServers} onServersChange={loadServers} />
            </div>
            <div className="sync-action-grid">
                <div className="sync-action-list">
                    <SyncLinksList />
                </div>
                <div className="sync-action-sidebar">
                    <SyncActionsPanel />
                </div>
            </div>
        </div>
    );
};
